import {LISTING_SECTION_IDS} from '../common/listingSections.js'
import {
  PATHS as sharedPaths,
  PATHS_BY_LISTING_SECTION_ID as sharedPathsByListingSectionId,
  STOCK_PATHS_BY_LISTING_SECTION_ID as sharedStockPathsByListingSectionId
} from '../common/paths.js'

// Define only the paths that are different from the common ones
export const PATHS = {
  ...sharedPaths,
  ADS_LIST_NEW_BUGGIES: '/nuevas/buggy/',
  ADS_LIST_NEW_MINIMOTOS: '/nuevas/minimotos/',
  ADS_LIST_NEW_QUADS: '/nuevas/quads/',
  ADS_LIST_NEW: '/nuevas/',
  ADS_LIST_SECOND_HAND_BUGGIES: '/segunda-mano/buggy/',
  ADS_LIST_SECOND_HAND_CLASSICS: '/segunda-mano/clasicas/',
  ADS_LIST_SECOND_HAND_MINIMOTOS: '/segunda-mano/minimotos/',
  ADS_LIST_SECOND_HAND_QUADS: '/segunda-mano/quads/',
  ADS_LIST_SECOND_HAND: '/segunda-mano/'
}

// Define only the paths by listing section id that are different from the common ones
export const PATHS_BY_LISTING_SECTION_ID = {
  ...sharedPathsByListingSectionId,
  [LISTING_SECTION_IDS.BUGGIES_NEW_VEHICLES]: PATHS.ADS_LIST_NEW_BUGGIES,
  [LISTING_SECTION_IDS.BUGGIES_SECOND_HAND_VEHICLES]: PATHS.ADS_LIST_SECOND_HAND_BUGGIES,
  [LISTING_SECTION_IDS.CLASSIC_MOTOS_VEHICLES]: PATHS.ADS_LIST_SECOND_HAND_CLASSICS,
  [LISTING_SECTION_IDS.MINIMOTOS_NEW_VEHICLES]: PATHS.ADS_LIST_NEW_MINIMOTOS,
  [LISTING_SECTION_IDS.MINIMOTOS_SECOND_HAND_VEHICLES]: PATHS.ADS_LIST_SECOND_HAND_MINIMOTOS,
  [LISTING_SECTION_IDS.NEW_VEHICLES]: PATHS.ADS_LIST_NEW,
  [LISTING_SECTION_IDS.QUADS_AND_ATVS_NEW_VEHICLES]: PATHS.ADS_LIST_NEW_QUADS,
  [LISTING_SECTION_IDS.QUADS_AND_ATVS_SECOND_HAND_VEHICLES]: PATHS.ADS_LIST_SECOND_HAND_QUADS,
  [LISTING_SECTION_IDS.SECOND_HAND_VEHICLES]: PATHS.ADS_LIST_SECOND_HAND
}

// Define only the stock paths by listing section id that are different from the common ones
export const STOCK_PATHS_BY_LISTING_SECTION_ID = {
  ...sharedStockPathsByListingSectionId
}
